
<main>
    <div class="jobs">
        <h4>પેટા કાર્યક્રમ</h4>
        <hr>
        <div class="filtering">
            <form>
                <input placeholder="શોધો..." type="search" #filter (keyup)="applyFilter($event)" class="form-control"
                    aria-label="Search box">
                <i class="ti ti-search"></i>
            </form>
        </div>
        <div>
            <div class="main-members">
                <a class="member-list-item" *ngFor="let data of getSubEventList">

                    <div class="flex1" (click)="goToEventDonor(data)">
                        <h5>{{data.sub_event_name}}</h5>
                        <small>મુખ્ય કાર્યક્રમ : {{data.event_name}}</small><br>
                        <small>તારીખ : {{data.from_date | date: 'dd/MM/yyyy'}} થી {{data.to_date | date:
                            'dd/MM/yyyy'}}</small>
                    </div>
                </a>
            </div>
        </div>
    </div>
</main>